export const ROLE = {
    ADMINISTRATOR: '8ec4c6ae-a070-4a37-aca2-9df61b8844c8',
    USER_ADMIN: '496b45d8-b036-4877-bd67-6353096e0fdf',
    REVIEWER: '84e075d2-8529-464c-b46c-42ccbc78b8f6',
    PLANNER: '939a37a5-3fe0-460b-964b-67c29287d492',
    BOOKING_REQUESTER: '40d00bd0-c67e-45c7-9ccc-00cee0bbb9f8',
    MANAGER: 'a0189e34-57fd-4448-86b2-ffd184b9b3f5',
    QC_TECHNICIAN: 'c81ba03d-9f78-43aa-b8b3-8fd262c499e2',
    QC_INSPECTOR: '4024ad67-867b-4b78-a17d-37f9cd7229ae',
    CARTON_INSPECTOR: '5c02d22a-60b8-4574-be6c-6819cf56f98f',
    CUSTOMER: '604ea866-22a8-4d2e-a352-1fe839f87a10'
} as const;
